export default __webpack_public_path__ + "static/media/down-arrow.da6db058.svg";